// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2dDoQ","amount":"Amount_amount__2a0pN","tip":"Amount_tip__33AUm","tipHeader":"Amount_tipHeader__1iyjq","tipsWrap":"Amount_tipsWrap__2JrQn"};